import React, { Component } from 'react'
import AdminRestaurantList from '../restaurants/admin/AdminRestaurantList'
import AdminRestaurantListCreate from '../restaurants/admin/AdminRestaurantListCreate'
import AdminRestaurantListDelete from '../restaurants/admin/AdminRestaurantListDelete'
import AdminPendingReview from '../restaurants/admin/AdminPendingReview'
import AdminIssuesList from '../restaurants/admin/AdminIssuesList'
import { connect } from 'react-redux'
import { firestoreConnect } from 'react-redux-firebase'
import { compose } from 'redux'
import { Redirect, Link } from 'react-router-dom'
import { addFavorite } from '../../store/actions/restaurantActions'
import { tagFunctions } from '../restaurants/Tags'
import { hoursFunctions } from '../restaurants/Hours'
import { deleteGuestUser, deleteGuestUserFavorites, newDistance } from '../../store/actions/restaurantActions'
import firebase from '../../config/fbConfig'

// var testHTML =require('./Test.html');
// var template = {testHTML: testHTML};
 // <iframe src={perf }></iframe>

class GenerateHTML extends Component {

// state = {
//   userIds:["05t9uuv2gDbKmvRcjhg9B36RCnB3","0Wzyu2Tt2wggi1i9djlKedXLlcL2"]
// }

downloadRestaurantFile = () => {
  var fullList = [];
  for(var rest in this.props.restaurants){
      fullList.push(this.props.restaurants[rest]);
  }
  if(fullList && this.props.restaurants && fullList.length===this.props.restaurants.length){
      console.log('done');
      var date = new Date();
      var strDate = date.getTime().toString();
       const element = document.createElement("a");
       const file = new Blob([JSON.stringify(fullList)],    
                   {type: 'text/plain;charset=utf-8'});
       element.href = URL.createObjectURL(file);
       element.download = "backup_restaurants_"+strDate+".txt";
       document.body.appendChild(element);
       element.click();
    }
 }

 downloadReddit = () => {
  var fullList = [];
  for(var rest in this.props.reddit){
      fullList.push(this.props.reddit[rest]);
  }
  console.log(fullList.length)
  console.log(this.props.reddit.length)
  if(fullList && this.props.reddit && fullList.length===this.props.reddit.length){
      console.log('done');
      var date = new Date();
      var strDate = date.getTime().toString();
       const element = document.createElement("a");
       const file = new Blob([JSON.stringify(fullList)],    
                   {type: 'text/plain;charset=utf-8'});
       element.href = URL.createObjectURL(file);
       element.download = "backup_reddit_"+strDate+".txt";
       document.body.appendChild(element);
       element.click();
    }
 }

downloadRedditCount = () => {
  var fullList = [];
  for(var rest in this.props.redditCount){
      fullList.push(this.props.redditCount[rest]);
  }
  if(fullList && this.props.redditCount && fullList.length===this.props.redditCount.length){
      console.log('done');
      var date = new Date();
      var strDate = date.getTime().toString();
       const element = document.createElement("a");
       const file = new Blob([JSON.stringify(fullList)],    
                   {type: 'text/plain;charset=utf-8'});
       element.href = URL.createObjectURL(file);
       element.download = "backup_redditCount_"+strDate+".txt";
       document.body.appendChild(element);
       element.click();
    }
 }

downloadRedditNotRelevant = () => {
  var fullList = [];
  for(var rest in this.props.redditNotRelevant){
      fullList.push(this.props.redditNotRelevant[rest]);
  }
  if(fullList && this.props.redditNotRelevant && fullList.length===this.props.redditNotRelevant.length){
      console.log('done');
      var date = new Date();
      var strDate = date.getTime().toString();
       const element = document.createElement("a");
       const file = new Blob([JSON.stringify(fullList)],    
                   {type: 'text/plain;charset=utf-8'});
       element.href = URL.createObjectURL(file);
       element.download = "backup_redditNotRelevant_"+strDate+".txt";
       document.body.appendChild(element);
       element.click();
    }
 }

downloadGames = () => {
  var fullList = [];
  for(var rest in this.props.deletedGames){
      fullList.push(this.props.deletedGames[rest]);
  }
  if(fullList && this.props.deletedGames && fullList.length===this.props.deletedGames.length){
      console.log('done');
      var date = new Date();
      var strDate = date.getTime().toString();
       const element = document.createElement("a");
       const file = new Blob([JSON.stringify(fullList)],    
                   {type: 'text/plain;charset=utf-8'});
       element.href = URL.createObjectURL(file);
       element.download = "backup_deletedGames_"+strDate+".txt";
       document.body.appendChild(element);
       element.click();
    }
 }


downloadAdvertisements = () => {
  var fullList = [];
  for(var rest in this.props.advertisements){
      fullList.push(this.props.advertisements[rest]);
  }
  if(fullList && this.props.advertisements && fullList.length===this.props.advertisements.length){
      console.log('done');
      var date = new Date();
      var strDate = date.getTime().toString();
       const element = document.createElement("a");
       const file = new Blob([JSON.stringify(fullList)],    
                   {type: 'text/plain;charset=utf-8'});
       element.href = URL.createObjectURL(file);
       element.download = "backup_advertisements_"+strDate+".txt";
       document.body.appendChild(element);
       element.click();
    }
 }

guestUserDistancelist = () => {
  console.log(this.props.user.distanceList)
  this.props.newDistance(this.props.user.distanceList)
 }

downloadUserFile = () => {
  var fullList = [];
  for(var user in this.props.users){
      console.log(this.props.users[user]['address'])
      console.log(this.props.users[user]['state'])
      fullList.push(this.props.users[user]);
  }
  if(fullList && this.props.users && fullList.length===this.props.users.length){
      console.log('done');
      var date = new Date();
      var strDate = date.getTime().toString();
       const element = document.createElement("a");
       const file = new Blob([JSON.stringify(fullList)],    
                   {type: 'text/plain;charset=utf-8'});
       element.href = URL.createObjectURL(file);
       element.download = "backup_users_"+strDate+".txt";
       document.body.appendChild(element);
       element.click();
    }
 }

 // isUserFile = () => {
 //  var fullList = [];
 //  for(var restaurant in this.props.restaurants){
 //      if(this.props.restaurants[restaurant].user)
 //      fullList.push(this.props.restaurants[restaurant].restaurantId);
 //  }
 //  console.log(fullList);
 // }

 downloadGuestFile = () => {
  var fullList = [];
  for(var user in this.props.users){
    if(this.props.users[user]['firstName']==='Guest'){
      fullList.push(this.props.users[user]['id']);
    }
  }
  if(fullList && this.props.users){
      console.log('done');
      var date = new Date();
      var strDate = date.getTime().toString();
       const element = document.createElement("a");
       const file = new Blob([JSON.stringify(fullList)],    
                   {type: 'text/plain;charset=utf-8'});
       element.href = URL.createObjectURL(file);
       element.download = "guest_uids_"+strDate+".txt";
       document.body.appendChild(element);
       element.click();
    }
 }

async getMarker() {
    const snapshot = firebase.firestore().collection('users/Y5TnEY8bZ5bi6Lm7KfRAQf06lji1/favorites').get();
    return snapshot.docs.map(doc => doc.data());
}

async getMarkers(userId) {
  const markers = [];
  await firebase.firestore().collection('users/'+userId+'/favorites').get()
    .then(querySnapshot => {
      querySnapshot.docs.forEach(doc => {
      markers.push(doc.id);
    });
  });
  return markers;
}

deleteGuestUsersFavorites = () => {
  var userIds = this.state.userIds;
  for(var userId in userIds.slice(0,1)){
    console.log(userIds[userId]);
    this.getMarkers(userIds[userId]).then((result) => this.props.deleteGuestUserFavorites(userIds[userId], result[0]));
    //this.getMarkers(userIds[userId]).then((result) => console.log(userIds[userId], result[0]));
  }
  this.setState({
    userIds:userIds.slice(1)
  })   
  console.log(userIds.length)
  //this.getMarkers(userId).then((result) => this.props.deleteGuestUserFavorites(userId, result[0]));
  //this.props.deleteGuestUserFavorites('05t9uuv2gDbKmvRcjhg9B36RCnB3');
}

//add protections here to make sure user is guest and make 'are you sure' modal
 deleteGuestUsers = () => {
  var fullList = [];
  for(var user in this.props.users){
    if(this.props.users[user]['firstName']==='Guest'){
      fullList.push(this.props.users[user]['id']);
      this.props.deleteGuestUser(this.props.users[user]['id']);
    }
  }
  if(fullList && this.props.users){
      console.log('done');
      console.log(fullList);
    }
 }


downloadFavorites = () => {
var fullList = [];
  var arrayReview = Object.entries(this.props.favorites);
  fullList = arrayReview;
  if(arrayReview){
      console.log('done');
      var date = new Date();
      var strDate = date.getTime().toString();
       const element = document.createElement("a");
       const file = new Blob([JSON.stringify(fullList)],    
                   {type: 'text/plain;charset=utf-8'});
       element.href = URL.createObjectURL(file);
       element.download = "backup_favorites_"+strDate+".txt";
       document.body.appendChild(element);
       element.click();
  }
}

downloadPoints = () => {
var fullList = [];
  var arrayReview = Object.entries(this.props.points);
  fullList = arrayReview;
  if(arrayReview){
      console.log('done');
      var date = new Date();
      var strDate = date.getTime().toString();
       const element = document.createElement("a");
       const file = new Blob([JSON.stringify(fullList)],    
                   {type: 'text/plain;charset=utf-8'});
       element.href = URL.createObjectURL(file);
       element.download = "backup_points_"+strDate+".txt";
       document.body.appendChild(element);
       element.click();
  }
}

downloadPendingCreate = () => {
var fullList = [];
  if(this.props.pendingCreate){
    var arrayReview = Object.entries(this.props.pendingCreate);
    fullList = arrayReview;
    if(arrayReview){
        console.log('done');
        var date = new Date();
        var strDate = date.getTime().toString();
         const element = document.createElement("a");
         const file = new Blob([JSON.stringify(fullList)],    
                     {type: 'text/plain;charset=utf-8'});
         element.href = URL.createObjectURL(file);
         element.download = "backup_pendingCreate_"+strDate+".txt";
         document.body.appendChild(element);
         element.click();
    }  
  }
  else{
    console.log('no restaurants pending creation');
  }
  
}

downloadReviewFile = () => {
  var fullList = [];
  var arrayReview = Object.entries(this.props.reviews);
  fullList = arrayReview;
  if(arrayReview){
      console.log('done');
      var date = new Date();
      var strDate = date.getTime().toString();
       const element = document.createElement("a");
       const file = new Blob([JSON.stringify(fullList)],    
                   {type: 'text/plain;charset=utf-8'});
       element.href = URL.createObjectURL(file);
       element.download = "backup_reviews_"+strDate+".txt";
       document.body.appendChild(element);
       element.click();
    }
 }

render() {
    const { restaurants, users, reviews, auth } = this.props;
    // if (!auth.uid) return <Redirect to='/signin' />
    var isAdmin = auth.uid === "KXyK1sbPuOQamITgwh8c1gSAxOq2";
    
    let testList = generateRestaurant(restaurants);
  
    var tagList = tagFunctions.compileTags(restaurants);
    var tagList2 = [];
    for(var tag in tagList){
      tagList2.push([
      <div key="tagList">
        <span>{tagList[tag]["value"]}</span>
      </div>
      ])
    }

    return (
      <div className="userDashboardContainer" style={{display:"flex", flexFlow:"row", justifyContent:"space-around"}}>
	      { restaurants && users && reviews && auth &&
	      <div>

        { isAdmin && 
          <div>
          <button onClick={this.downloadRestaurantFile}>Download Restaurants</button>
          <button onClick={this.downloadReddit}>Download Reddit</button>
          <button onClick={this.downloadRedditCount}>Reddit Count</button>
          <button onClick={this.downloadRedditNotRelevant}>Reddit Not Relevant</button>
          <button onClick={this.downloadUserFile}>Download Users</button>
          <button onClick={this.downloadReviewFile}>Download Reviews</button>
          <button onClick={this.downloadGuestFile}>Download Guest Uids</button>
          <button onClick={this.deleteGuestUsers}>Delete Guest Users</button>
          <button onClick={this.downloadFavorites}>Download Favorites</button>
          <button onClick={this.downloadPendingCreate}>Download PendingCreate</button>
          <button onClick={this.downloadPoints}>Download Points</button>
          <button onClick={this.downloadAdvertisements}>Download Advertisements</button>
          <button onClick={this.guestUserDistancelist}>GU distance list</button>
          <button onClick={this.downloadGames}>Deleted Games</button>

          </div>
        }

        <div style={{textAlign:"center", padding:"20px", maxWidth:"320px", overflow:"auto"}}>
		      <div key="testList">
		      { testList && testList }
		      </div>

		      <div key="tagList">
		      { tagList2 && tagList2 }
		      </div>
        </div>

	      </div>
	      }
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const user = state.firestore.data.users
                && state.firestore.data.users[state.firebase.auth.uid]
  return {
    auth: state.firebase.auth,
    restaurants: state.firestore.ordered.restaurants,
    reddit: state.firestore.ordered.reddit,
    users: state.firestore.ordered.users,
    reviews: state.firestore.data.restaurantReviews2,
    favorites: state.firestore.data.favorites,
    pendingCreate: state.firestore.data.pendingCreate,
    points: state.firestore.data.points,
    advertisements: state.firestore.ordered.advertisements,
    deletedGames: state.firestore.ordered.deletedGames,
    redditCount: state.firestore.ordered.redditCount,
    redditNotRelevant: state.firestore.ordered.redditNotRelevant,
    user
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    deleteGuestUser: (userId) => dispatch(deleteGuestUser(userId)),
    deleteGuestUserFavorites: (userId, favId) => dispatch(deleteGuestUserFavorites(userId, favId)),
    newDistance: (distanceList) => dispatch(newDistance(distanceList))

  }
}


export default connect(mapStateToProps, mapDispatchToProps)(GenerateHTML)

function generateRestaurant(restaurants){
    console.log(restaurants);
    var testList = [];
    var fullList = [];
    for(var rest in restaurants){
      fullList.push(restaurants[rest]);
      testList.push([

        <div itemScope itemType="http://schema.org/Restaurant" 
        key={restaurants[rest].name}>
          <span>{restaurants[rest].name}</span><br/>
          <span>{restaurants[rest].address}, {restaurants[rest].city}&nbsp;
           {restaurants[rest].state} {restaurants[rest].zip}</span><br/>
          <span>{restaurants[rest].phoneNumber}</span><br/>
          <a href={restaurants[rest].url}>Website</a><br/>
          <a href={restaurants[rest].orderUrl===""?
          restaurants[rest].menuUrl:restaurants[rest].orderUrl}>
          {restaurants[rest].orderUrl===""?"Menu":"Order Online"}</a>
          <hr/>
        </div>
      ]);  
    }   
    
    return testList;
}

{/*<script type="application/ld+json">
   {
      "@context": "https://schema.org",
      "@type": "Restaurant",
      "image": [
        "https://example.com/photos/1x1/photo.jpg",
        "https://example.com/photos/4x3/photo.jpg",
        "https://example.com/photos/16x9/photo.jpg"
       ],
      "name": "restaurants[rest].name",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "148 W 51st St",
        "addressLocality": "New York",
        "addressRegion": "NY",
        "postalCode": "10019",
        "addressCountry": "US"
      },
      "review": {
        "@type": "Review",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "4",
          "bestRating": "5"
        },
        "author": {
          "@type": "Person",
          "name": "Lillian Ruiz"
        }
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 40.761293,
        "longitude": -73.982294
      },
      "url": "https://www.example.com/restaurant-locations/manhattan",
      "telephone": "+12122459600",
      "servesCuisine": "American",
      "priceRange": "$$$",
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": [
            "Monday",
            "Tuesday"
          ],
          "opens": "11:30",
          "closes": "22:00"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": [
            "Wednesday",
            "Thursday",
            "Friday"
          ],
          "opens": "11:30",
          "closes": "23:00"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": "Saturday",
          "opens": "16:00",
          "closes": "23:00"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": "Sunday",
          "opens": "16:00",
          "closes": "22:00"
        }
      ],
      "menu": "https://www.example.com/menu",
      "acceptsReservations": "True"
    }
</script>*/}